export const FEATURE_TOGGLES = {
    initFormControllerWithTimeout: 'initFormControllerWithTimeout',
    dateTimeOffsetValidationEnabled: 'dateTimeOffsetValidationEnabled'
};
/**
 * Hotfix until `@wix/wix-experiments` is updated to 3.2.35 or later in viewer-platform,
 * that supports value `"B"` as true.
 */ export const isFeatureEnabled = (experiments, key)=>experiments.get(key) === 'B' || experiments.enabled(key);

//# sourceMappingURL=feature-toggles.js.map